/**
 * Copyright (c) Qwoach LLC 2026. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */
import BaseObject from "@shared/BaseObject.js";

export default class GenogramSelectionModeController extends BaseObject {

	constructor({
		cy,
		toolbar,
		onSelectionModeChanged,
	}) {
		super();
		this.cy = cy;
		this.toolbar = toolbar;
		this.onSelectionModeChanged = onSelectionModeChanged || (() => {});
		this.isTemporaryBoxSelectionActive = false;
		this.temporaryBoxSelectionPreviousState = null;

		this.handleShiftKeyDown = this.handleShiftKeyDown.bind(this);
		this.handleShiftKeyUp = this.handleShiftKeyUp.bind(this);
		this.handleWindowBlur = this.handleWindowBlur.bind(this);

		document.addEventListener('keydown', this.handleShiftKeyDown);
		document.addEventListener('keyup', this.handleShiftKeyUp);
		window.addEventListener('blur', this.handleWindowBlur);
	}

	handleShiftKeyDown(event) {
		if (event.key !== 'Shift') {
			return;
		}
		if (this.isInputFocused()) {
			return;
		}
		if (this.isTemporaryBoxSelectionActive) {
			return;
		}

		this.isTemporaryBoxSelectionActive = true;
		this.temporaryBoxSelectionPreviousState = this.isBoxSelectionEnabled();
		this.setBoxSelectionMode(true);
	}

	handleShiftKeyUp(event) {
		if (event.key !== 'Shift') {
			return;
		}

		this.restoreTemporaryBoxSelectionState();
	}

	handleWindowBlur() {
		this.restoreTemporaryBoxSelectionState();
	}

	shouldKeepSelectionModeAfterBoxSelect() {
		return this.isTemporaryBoxSelectionActive;
	}

	handleBoxSelectToolbarCommand(isEnabled) {
		if (this.isTemporaryBoxSelectionActive) {
			this.temporaryBoxSelectionPreviousState = isEnabled;
		}
		this.setBoxSelectionMode(isEnabled);
	}

	restoreTemporaryBoxSelectionState() {
		if (!this.isTemporaryBoxSelectionActive) {
			return;
		}

		this.isTemporaryBoxSelectionActive = false;
		this.setBoxSelectionMode(this.temporaryBoxSelectionPreviousState);
		this.temporaryBoxSelectionPreviousState = null;
	}

	setBoxSelectionMode(isEnabled) {
		let command = this.toolbar?._options.commands.find(it => it.command === 'boxselect');
		if (command) {
			this.toolbar.rerender('boxselect', {selected: isEnabled});
		}

		this.cy.userPanningEnabled(!isEnabled);
		this.cy.boxSelectionEnabled(isEnabled);
		this.cy.userZoomingEnabled(true);
		this.cy.zoomingEnabled(true);
		this.onSelectionModeChanged(isEnabled);
	}

	isBoxSelectionEnabled() {
		let command = this.toolbar?._options.commands.find(it => it.command === 'boxselect');
		if (command) {
			return !!command.selected;
		}

		return !this.cy.userPanningEnabled();
	}
	isInputFocused() {
		const active = document.activeElement;
		return !!(
			active &&
			(
				active.tagName === 'INPUT' ||
				active.tagName === 'TEXTAREA' ||
				active.isContentEditable
			)
		);
	}

	destroy() {
		document.removeEventListener('keydown', this.handleShiftKeyDown);
		document.removeEventListener('keyup', this.handleShiftKeyUp);
		window.removeEventListener('blur', this.handleWindowBlur);
	}
}
